import styled from "styled-components";

const PanelContainer = styled.div`
  width: 100%;
  padding: 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  background: "transparent";
`;

export default PanelContainer;
